const env = process.env.NODE_ENV === 'development' ? process.env : window;

export default env;
